import Checkbox from '../forms/Checkbox';
import React, { Component } from 'react';
import { Radio } from '@material-ui/core';
import Input from '../forms/Input';

class LabelConfigRow extends Component {
    _toggleSelect = () => this.props.onSelect(this.props.item.id, this.props.item);

    _handleLabelChange = value => {
        if (this.props.onLabelChange) {
            this.props.onLabelChange(this.props.item, value);
        }
    };

    _handleLabelClick = e => {
        e.stopPropagation();
    };

    _handleColorChange = e => {
        e.stopPropagation();
        if (this.props.onColorChange) {
            this.props.onColorChange(this.props.item, e.target.value);
        }
    };

    _handleDefaultSelectedChange = e => {
        e.stopPropagation();
        if (this.props.onDefaultSelectedChange) {
            this.props.onDefaultSelectedChange(this.props.item);
        }
    };

    _renderLabel = () => {
        const isEditable = this.props.item.editable !== false;
        const isEmpty = !(this.props.item.label || '').trim();
        const showError = this.props.labelRequired && isEmpty;
        return (
            <Input
                type="text"
                value={this.props.item.label || ''}
                onChange={this._handleLabelChange}
                onClick={this._handleLabelClick}
                className="ckp-label-text-input"
                disabled={!isEditable}
                inputProps={{ 'data-label-id': this.props.item.id }}
                errorMessage={showError ? 'Required' : undefined}
                showErrorMessage={showError}
            />
        );
    };

    _renderColor = () => {
        const isEditable = this.props.item.editable !== false;
        return (
            <div className="ckp-input-wrapper">
                <input
                    type="color"
                    value={this.props.item.color || '#000000'}
                    onChange={this._handleColorChange}
                    onClick={e => e.stopPropagation()}
                    className="ckp-label-color-input"
                    disabled={!isEditable}
                />
            </div>
        );
    };

    _renderDefaultSelected = () => {
        return (
            <div className="ckp-input-wrapper">
                <Radio
                    checked={this.props.item.defaultSelected || false}
                    onChange={this._handleDefaultSelectedChange}
                    onClick={e => e.stopPropagation()}
                    className="ckp-label-default-radio"
                    name="defaultSelected"
                    value={this.props.item.id}
                />
            </div>
        );
    };

    render() {
        const blocked = !(this.props.enableRowFunction && this.props.enableRowFunction(this.props.item));
        const selectBlocked = !(this.props.enableSelectFunction && this.props.enableSelectFunction(this.props.item));

        return (
            <tr
                className={`ckp-tables-body-row ${blocked ? 'is-blocked' : ''} ${
                    this.props.allowOpen && !blocked ? 'is-clickable' : ''
                }`}
            >
                {this.props.selectable ? (
                    <td className="ckp-tables-select-column">
                        {blocked || selectBlocked ? null : (
                            <Checkbox
                                checked={this.props.selected}
                                name={this.props.item.id}
                                onChange={this._toggleSelect}
                            />
                        )}
                    </td>
                ) : null}
                <td className="ckp-tables-rest-column">
                    <div className="ckp-tables-body-column">{this._renderLabel()}</div>
                    <div className="ckp-tables-body-column">{this._renderColor()}</div>
                    <div className="ckp-tables-body-column">{this._renderDefaultSelected()}</div>
                </td>
            </tr>
        );
    }
}

LabelConfigRow.defaultProps = { allowOpen: true };

export default LabelConfigRow;
